import { Button, Group, Modal, Select, Stack, Text } from "@mantine/core";
import { IApp, IBoard } from "@mctypes/global.types";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { CreateNewButton } from "..";
import { MCApplicationsUrlEnum } from "../../mc-shared/sharedConstants";

const CreateItemWithBoardSelectorModal: React.FC<{
  boards: Partial<IBoard>[];
  defaultIssueBoard?: { name: string; _id: string };
  onCreate: (boardId: string) => void;
  modalTitle: string;
  opened: boolean;
  onClose: () => void;
  currentApp: MCApplicationsUrlEnum;
  apps: IApp[];
  projectId: string;
  createButtonText?: string;
}> = ({
  boards,
  onCreate,
  modalTitle,
  opened,
  onClose,
  apps,
  currentApp,
  projectId,
  createButtonText = "Opprett",
  defaultIssueBoard,
}) => {
  const [selectedBoard, setSelectedBoard] = React.useState<Partial<IBoard>>(null);

  useEffect(() => {
    if (defaultIssueBoard != null) {
      setSelectedBoard(boards.find((board) => board._id === defaultIssueBoard._id));
    } else if (boards.length > 0) {
      setSelectedBoard(boards[0]);
    } else {
      setSelectedBoard(null);
    }
  }, [defaultIssueBoard, boards]);

  const history = useHistory();

  const fullApp = apps.find((app) => app.name === currentApp);
  const registerUrl = `/project/${projectId}/${fullApp?.label};`;

  const goToRegister = () => {
    history?.push(registerUrl);
  };

  return (
    <Modal
      zIndex={2000}
      opened={opened}
      onClose={onClose}
      size="md"
      withinPortal={true}
      yOffset={140}
      title={
        <Text fz="md" fw={500}>
          {modalTitle}
        </Text>
      }
    >
      <Stack gap="sm">
        {boards.length > 0 ? (
          <Stack gap="xs">
            <Text fz="sm" fw={500}>
              Velg register
            </Text>
            <Select
              value={selectedBoard?._id}
              styles={{ dropdown: { zIndex: 2200 } }}
              onChange={(value) => setSelectedBoard(boards.find((board) => board._id === value))}
              data={boards.map((board) => ({ value: board._id, label: board.name }))}
            />
          </Stack>
        ) : (
          <Stack gap="xs">
            <Text fz="sm" c="blue.6">
              Det er ikke satt opp noe register ennå.
            </Text>
            <Button variant="subtle" onClick={goToRegister}>
              Gå til registeradministrasjon for {apps.find((app) => app.name === currentApp)?.label}
            </Button>
          </Stack>
        )}

        <Group justify="space-between">
          <Button variant="default" onClick={onClose}>
            Lukk
          </Button>
          <CreateNewButton
            disabled={selectedBoard == null}
            label={createButtonText}
            onClick={() => onCreate(selectedBoard._id)}
          />
        </Group>
      </Stack>
    </Modal>
  );
};

export default CreateItemWithBoardSelectorModal;
